import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useLocation } from 'react-router';
import {
  connectDevStorage,
  connectDrive,
  disconnectDrive,
  DRIVE_QUERY_KEY,
  getDriveStatus,
} from './drive';

/** Drive connection status plus connect/disconnect actions. */
export function useDrive() {
  const queryClient = useQueryClient();
  const { pathname, search } = useLocation();
  const status = useQuery({
    queryKey: DRIVE_QUERY_KEY,
    queryFn: ({ signal }) => getDriveStatus(signal),
  });
  const refresh = () => queryClient.invalidateQueries({ queryKey: DRIVE_QUERY_KEY });
  const connect = useMutation({
    mutationFn: () => connectDrive(`${pathname}${search}`),
    onSettled: refresh,
  });
  const connectDev = useMutation({ mutationFn: connectDevStorage, onSettled: refresh });
  const disconnect = useMutation({ mutationFn: disconnectDrive, onSettled: refresh });
  return { status, connect, connectDev, disconnect };
}
